export interface IAnalyticsData {
	action: string;
	lang: string;
	source: string;
	type: string;
	userInfoScreenWidth: string;
	userInfoViewPortSize: string;
	userInfoPixelRatio: number;
	text: string;
	origin: string;
	url: string;
	[key: string]: any;
}

let ACTION_DEFAULTS: Partial<IAnalyticsData> = {
	userInfoScreenWidth: screen && screen.width && screen.height ? `${screen.width}×${screen.height}` : 'undetectable',
	userInfoViewPortSize: `${document.documentElement.clientWidth}×${document.documentElement.clientHeight}`,
	userInfoPixelRatio: window.devicePixelRatio,
};

export function setAnalyticsData(data: Partial<IAnalyticsData>) {
	ACTION_DEFAULTS = {
		...ACTION_DEFAULTS,
		...data,
	};
}

export function setAnalyticsConfig(data: object) {
	if (!window.DOT || !data) {
		return;
	}

	window.DOT.cfg(data);
}

export function analytics(data: Partial<IAnalyticsData>): void {
	if (!window.DOT || !data) {
		return;
	}

	window.DOT.hit('event', {
		d: {
			...ACTION_DEFAULTS,
			...data,
		} as IAnalyticsData,
	});
}

function analyticsClick(event: MouseEvent) {
	if (!window.DOT) {
		return;
	}

	// najit rodic, ktery ma pozadovany atribut nebo je spravneho typu
	let dataNode = null;

	// vysledna data, co se zaloguji
	const data: Partial<IAnalyticsData> = {};

	let tmp = event.target as HTMLElement;

	while (tmp && tmp.getAttribute) {
		// na tomhle se zastavime
		if (tmp.getAttribute('data-log-action')) {
			dataNode = tmp;
			break;
		}
		// tenhle bereme, ale jdeme dal
		if ((tmp.nodeName.match(/^(a|button)$/ui) || tmp.getAttribute('type') === 'button') && !tmp.hasAttribute('data-log-ignore')) {
			dataNode = tmp;
			data.action = 'click';
		}
		tmp = tmp.parentNode as HTMLElement;
	}

	// vzniklo to mimo nas zajem
	if (!dataNode) {
		return;
	}

	if (dataNode.href) {
		data.url = dataNode.href;
	}

	// vysosame pripadna logovaci metadata
	for (let index = 0; index < dataNode.attributes.length; index++) {
		const attr = dataNode.attributes[index];
		const match = attr.nodeName.match(/^data-log-(.*)/u);

		if (match) {
			data[match[1]] = attr.value;
		}
	}

	if (data.action === 'click') {
		data.text = data.text || dataNode.textContent || '';
		if (!data.text && dataNode.id) {
			data.text = `#${dataNode.id}`;
		}
		if (!data.text && dataNode.className) {
			data.text = `.${dataNode.className}`;
		}
	}

	analytics(data);
}

document.addEventListener('click', analyticsClick, true);
